export default __webpack_public_path__ + "static/media/right4.649d053b.png";